import React,{memo, useEffect} from 'react';
import {setArrayIndexes} from '../../../../../Utils/CommonFunctions';
import FormInputFields from '../../../../../Components/FormInputFields';
import { connect } from 'react-redux';
import {isSet} from '../../../../../Utils/CommonFunctions';


const WindowListComp = (props)=>{
    const {payload} = props;
    const windowListObj  = {
                type:'PickList',
                options:[...props.windowsList],
                value:payload.window_id,
                changeHandler:(val)=>props.updateWindowId(val)
    }
    useEffect(()=>{
        
        if(isSet(payload.is_response,false)===true){
            // console.log('payload',payload); 
        }
        if(isSet(payload.field_expression,null)===null){
            if(payload.window_id!==''){
                props.generateWindowFields(payload.window_id);
            }else if(isSet(payload.window_id,null)===null && isSet(payload.fields,[]).length>0 && isSet(payload.is_constant,false)===true){
                props.updateFields([]);
            }
        }
    },[payload.window_id]);

    useEffect(()=>{
        const windowFields = props.windowFields[payload.window_id];
        if(isSet(payload.window_id,null)!==null && isSet(windowFields,null)!==null){
            if(payload.fields.length===0){
            const updatePayload = setArrayIndexes({...payload,'fields':getWindowDependentFields(windowFields)});
            // console.log('updatePayload',updatePayload);
            props.updateFields(updatePayload.fields);
            }
        }else {
            // props.updateFields([]);
        }
        

    },[props.windowFields[payload.window_id]]);

    const getWindowDependentFields = (windowFields)=>{
        let arrayElementFields = [];
        try{
            //console.log('arrrr',windowFields.fields_with_filters.window_fields);
            windowFields.fields_with_filters.window_fields.map((item)=>{
                //Ignore fields for add/edit form
                // if(item.assign_field===isSet(props.isAssignFieldOnly,true)){ return false;}
                if(item.filter_window===true){return false;}
                //isSet(props.isAssignFieldOnly,true)
                let fieldTypeName = item.field_type;
                //Filter Blank, ImageUpload and FileUpload fields
                if(fieldTypeName!=="Blank" && fieldTypeName!=='ImageUpload' && fieldTypeName!=='FileUpload'){
                    if(item.field_type==='Lookup'){
                        fieldTypeName='Object';
                    }else if(item.field_type==='MultiLookup'){
                        fieldTypeName='Array';
                    }else if(item.field_type==='PickList'){
                        fieldTypeName = 'TextInput';
                    }
                    const varTypeIndex  = isSet(props.variablesAndFields,[]).findIndex((i=>i.type_name===fieldTypeName));
                    // console.log('varTypeIndex',isSet(props.variablesAndFields,[]),varTypeIndex);
                    arrayElementFields.push({
                        function_type:props.function_type,
                        //name:(props.screen==='Steps')?isSet(item.api_field_name,item.field_name):item.field_name,
                        name:item.field_name,
                        variable_name:item.field_name,
                        variable_type:'GLOBAL', 
                        is_constant:false,
                        fields:(isSet(item.dependent_layout,null)!==null)?getWindowDependentFields(isSet(item.dependent_layout,null)):[],
                        constant_value:'',
                        field_type_id:(varTypeIndex!==-1)?isSet(props.variablesAndFields,[])[varTypeIndex].id:item.fieldTypeId,
                        fieldtype_name:fieldTypeName,//item.field_type,
                        max_value:item.max,
                        decimal_places:item.decimal_places,
                        field_expression:item.id,//'${'+item.api_field_name+'}',
                        api_name:isSet(item.api_field_name.replace(/ /g, "_"),''),
                        table_descriptor_id:isSet(item.id,'')
                      });
                }
            })
         
        }catch(e){

        }
        return arrayElementFields;
    }
    //if(isSet(payload.field_expression,null)!==null || isSet(payload.is_response,false)===true){
    if(isSet(payload.field_expression,null)!==null ){
        return (<></>)
    }
    return(
        <>
            <div className='row'>
                     <div className='col-4'>
                         <div className="form-group">
                             <label>Window</label>
                             <FormInputFields {...windowListObj} />
                         </div>
                     </div>
                 </div>
                 </>
    )
}

WindowListComp.defaultProps = {
    screen:'',
    function_type:'STEPS'
}

const mapStateToProps = (state) => { 
    return {
        // windowFields:state.StepsFlowReducer.windowFields,
        // windowsList:state.StepsFlowReducer.windowsList,
    };
}

// const isDiffProps = (prevProps,nextProps)=>{
//     // const evalVar = 'nodePayloadData.properties.data.window_id';
//     // console.log('evalVar',eval('prevProps+nodePayloadData.properties.data.window_id'));
//     try{
//         if(prevProps.nodePayloadData.properties.data.window_id===nextProps.nodePayloadData.properties.data.window_id && prevProps.nodePayloadData.properties.data.custom_limit===nextProps.nodePayloadData.properties.data.custom_limit && prevProps.nodePayloadData.properties.data.number_records_to_store===nextProps.nodePayloadData.properties.data.number_records_to_store){
//             return true;
//         }
//     }catch{

//     }
// }
  export default
    connect(
      mapStateToProps, 
      null
    )((memo(WindowListComp)));